import React from 'react';
import type TreeIndex from '../../../../classes/pieces/TreeIndex';
import type BordereauStateType from '../../../../constants/liquidation/bordereaux/BordereauStateType';
import TreeNodeType from '../../../../constants/liquidation/TreeNodeType';
import type SensOptions from '../../../../interfaces/pieces/bordereaux/SensOptions';
import { SENS_TOUS } from '../../../../interfaces/pieces/bordereaux/SensOptions';

/**
 * États des bordereaux chargés du sens filtré, remontés au filtre d'état (seuls les états présents y sont
 * proposés). Recalculés quand l'arbre ou le sens change ; `onChange` n'est appelé qu'à un changement.
 */
const useEtatsVisibles = (
	index: TreeIndex,
	filterSens: SensOptions,
	onChange?: (states: Set<BordereauStateType>) => void,
): Set<BordereauStateType> => {
	const states = React.useMemo(() => {
		const visibles = new Set<BordereauStateType>();
		index.getRoots().forEach((entite) => {
			index.getChildren(entite.rowKey)?.forEach((row) => {
				if (
					row.nodeType === TreeNodeType.BORDEREAU &&
					row.bordereau &&
					(filterSens === SENS_TOUS || row.bordereau.sens === filterSens)
				) {
					visibles.add(row.bordereau.state.state);
				}
			});
		});
		return visibles;
	}, [index, filterSens]);

	React.useEffect(() => {
		onChange?.(states);
	}, [states, onChange]);

	return states;
};

export default useEtatsVisibles;
